/**
 * Summary Cards Component
 * Displays total earnings, income tax, NI, and pension contributions
 */
import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { PoundSterling, Receipt, Shield, Landmark } from 'lucide-react';

const SummaryCards = ({ totalYearEarnings, taxTotals, isAllYears }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      <Card className="bg-slate-800 border-slate-700">
        <CardContent className="p-3 sm:p-5">
          <div className="flex items-center justify-between">
            <div className="min-w-0">
              <p className="text-[10px] sm:text-xs text-slate-400 uppercase">{isAllYears ? 'Total Earnings' : 'Tax Year Earnings'}</p>
              <p className="text-lg sm:text-2xl font-bold text-amber-400 truncate">
                £{totalYearEarnings.toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
              </p>
            </div>
            <div className="p-2 sm:p-3 bg-amber-500/20 rounded-lg flex-shrink-0">
              <PoundSterling className="h-4 w-4 sm:h-5 sm:w-5 text-amber-400" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-slate-800 border-slate-700">
        <CardContent className="p-3 sm:p-5">
          <div className="flex items-center justify-between">
            <div className="min-w-0">
              <p className="text-[10px] sm:text-xs text-slate-400 uppercase">Income Tax Paid</p>
              <p className="text-lg sm:text-2xl font-bold text-red-400 truncate">
                £{(taxTotals?.tax || 0).toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
              </p>
            </div>
            <div className="p-2 sm:p-3 bg-red-500/20 rounded-lg flex-shrink-0">
              <Receipt className="h-4 w-4 sm:h-5 sm:w-5 text-red-400" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-slate-800 border-slate-700">
        <CardContent className="p-3 sm:p-5">
          <div className="flex items-center justify-between">
            <div className="min-w-0">
              <p className="text-[10px] sm:text-xs text-slate-400 uppercase">NI Paid</p>
              <p className="text-lg sm:text-2xl font-bold text-red-400 truncate">
                £{(taxTotals?.ni || 0).toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
              </p>
            </div>
            <div className="p-2 sm:p-3 bg-red-500/20 rounded-lg flex-shrink-0">
              <Shield className="h-4 w-4 sm:h-5 sm:w-5 text-red-400" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-slate-800 border-slate-700">
        <CardContent className="p-3 sm:p-5">
          <div className="flex items-center justify-between">
            <div className="min-w-0">
              <p className="text-[10px] sm:text-xs text-slate-400 uppercase">Pension Contributions</p>
              <p className="text-lg sm:text-2xl font-bold text-orange-400 truncate">
                £{(taxTotals?.pension || 0).toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
              </p>
            </div>
            <div className="p-2 sm:p-3 bg-orange-500/20 rounded-lg flex-shrink-0">
              <Landmark className="h-4 w-4 sm:h-5 sm:w-5 text-orange-400" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SummaryCards;
